import PropTypes from '~/lib/propTypes'
import getConfig from 'next/config'
import { escapeMarkup } from '~/utils/escapeMarkup'

const { publicRuntimeConfig } = getConfig()

const HomepageStructuredData = ({ hostname }) => (
  <>
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: escapeMarkup(
          JSON.stringify({
            '@context': 'http://schema.org',
            '@type': 'WebSite',
            '@name': 'Ticketswap',
            url: `https://${hostname}`,
            potentialAction: {
              '@type': 'SearchAction',
              target: `https://${hostname}/search?query={search_term_string}`,
              'query-input': 'required name=search_term_string',
            },
          })
        ),
      }}
    />
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: escapeMarkup(
          JSON.stringify({
            '@context': 'http://schema.org',
            '@type': 'Organization',
            url: 'https://www.ticketswap.com',
            logo: `${publicRuntimeConfig.NEXT_PUBLIC_CDN_URL}/static/images/facebook-image-squarable.png`,
            sameAs: [
              'https://www.facebook.com/TicketSwap',
              'https://www.twitter.com/TicketSwap',
              'https://www.instagram.com/ticketswap',
              'https://medium.com/ticketswap',
            ],
          })
        ),
      }}
    />
  </>
)

HomepageStructuredData.propTypes = {
  hostname: PropTypes.string.isRequired,
}

export default HomepageStructuredData
